import { Injectable } from "@angular/core";
import { WizardFlowContext } from "../../../wizard-flow-context.model";
import { GenericStepFactory } from "./generic-step.factory";
import { NextStepDeciderFactory } from "./next-step-decider.factory";
import { ICreateStep } from "./step-factory.interface";
import { TypeOfLoanStep } from "../../type-of-loan-step.model";
import { TypeOfLoanStepConfig } from "../type-of-loan-step-config.model";

@Injectable()
export class TypeOfLoanStepFactory extends GenericStepFactory<TypeOfLoanStep> implements ICreateStep {

  constructor(nextStepDeciderFactory: NextStepDeciderFactory) {
    super(nextStepDeciderFactory, TypeOfLoanStep);
  }

  create(config: TypeOfLoanStepConfig, wizardFlowContext: WizardFlowContext): TypeOfLoanStep {
    const typeOfLoanStep = super.create(config, wizardFlowContext)
    typeOfLoanStep.showChildCareQuestionsForVALoans = config.showChildCareQuestionsForVALoans || false;
    return typeOfLoanStep;
  }

  configure(step: TypeOfLoanStep, config: TypeOfLoanStepConfig): void {
    super.configure(step, config);
    config.showChildCareQuestionsForVALoans = step.showChildCareQuestionsForVALoans;
  }
}
